import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Spinner, Table, Button, OverlayTrigger, Tooltip } from 'react-bootstrap'

// import DefaultButton from 'components/mycomponents/DefaultButton';
import { dateTimeFormat } from '../../../utils/FormatDate'

const Data = ({
    dataMain,
    actionDetail,
    actionChatting,
    numberStart,
    isLoading
}) => {
    return (
        <Table responsive striped hover bordered size="sm">
            <thead>
                <tr>
                    <th scope="col">No</th>
                    <th scope="col">Tanggal</th>
                    <th scope="col">Kode</th>
                    <th scope="col">Judul</th>
                    <th scope="col">Member</th>
                    <th scope="col">Operator</th>
                    <th scope="col">Status</th>
                    <th className="text-end" scope="col" width="10%">
                        Aksi
                    </th>
                </tr>
            </thead>
            <tbody>
                {
                    isLoading ? (<tr>
                        <td colSpan={6} align="center" valign="middle">
                            <Spinner animation="border  " className="me-2" />
                            <span className="fs-4">Loading ...</span>
                        </td>
                    </tr>) :
                    dataMain ? dataMain.map((val, idx) => {
                        return (
                            <tr key={idx}>
                                <td>{numberStart + 1 + idx}</td>
                                <td>{dateTimeFormat(val.dtadd)}</td>
                                <td>{val.vccode}</td>
                                <td>{val.vcname}</td>
                                <td>{val.vcmember}</td>
                                <td>{val.vcoperator}</td>
                                <td>{val.vcstatus}</td>
                                <td className="text-end">
                                    {/* <DefaultButton icon="info" title="Detail Data" variant="action" className="p-0 me-3" clickAction={actionDetail} clickParam={val.intid} /> */}
                                    <OverlayTrigger placement={'top'} overlay={<Tooltip>Chat</Tooltip>} >
                                        <Button onClick={() => actionChatting('chat', val.intid, val.intstatus, val.token_admin)} className="p-0 me-3" variant="action">
                                            <FontAwesomeIcon icon="comment" />
                                        </Button>
                                    </OverlayTrigger>
                                </td>
                            </tr>
                        );
                    }) : (
                        <tr>
                            <td colSpan={6}>Data Tidak Tersedia.</td>
                        </tr>
                    )
                }
            </tbody>
        </Table>
    );
}

Data.propTypes = {}

export default Data;